<template>
    <tr :class="trClass">
        <td @click.prevent="onClick">{{ cashing.id }}</td>
        <!-- <td @click.prevent="onClick">{{ cashing.customer.name }} ({{ cashing.customer.erp_id }})</td> -->
        <!-- <td><a :href="`mailto:` + cashing.email">{{ cashing.email }}</a></td> -->
        <td @click.prevent="onClick">{{ cashing.decoded_type }}</td>
        <td @click.prevent="onClick">{{ (cashing.ttc_amount / 100).toFixed(2) }}€</td>
        <td @click.prevent="onClick">{{ cashing.created_at | moment-date }}</td>
        <td @click.prevent="onClick">{{ cashing.decoded_payment_status }}</td>
        <td class="text-center">
            <div v-if="!cashing.manual_check_required">
                <div v-if="'authorized' != cashing.payment_status">
                    <button class="btn btn-complete btn-cons" v-if="cashing.payable" @click="$emit('make-cash-payment', cashing)">Encaisser</button>
                    <button class="btn btn-cons" @click="deletingCashing(cashing.id)" v-if="cashing.payment_status != 'paid'">Supprimer</button>
                </div>

                <div v-else>
                    <button class="btn btn-complete btn-cons" @click="$emit('capture-authorizations', cashing)">Capturer</button>
                    <button class="btn btn-cons" @click="$emit('cancel-authorizations', cashing)">Annuler</button>
                </div>
            </div>

            <div v-else>
                <span class="text-warning">Contrôle manuel nécessaire</span>
            </div>
        </td>
    </tr>
</template>

<script type="text/babel">
    import {mapState, mapActions} from 'vuex'

    export default {
        name:"CashTableItem",

        props: ['cashing', 'showDetails'],

        computed: {
            trClass () {
                return { shown: this.showDetails, 'has-details': true }
            },

            // detailIconClass() {
            //     return this.showDetails ? 'fa-angle-up' : 'fa-angle-down'
            // }
        },

        methods: {
            ...mapActions('cash', ['customerCashings', 'deleteCashing']),

            deletingCashing(params) {
                this.deleteCashing(params)
                    .then(() => {
                        let currentparams = this.filters
                        _.assign(currentparams, {page:this.currentPage})
                        this.$emit('cashing-deleted')
                    })
            },

            onClick ($event) {
                this.$emit('click', $event)
            },

        }
    }
</script>

<style lang="scss" scoped>
    button.btn:first-child { margin-bottom: 5px; }
</style>



// WEBPACK FOOTER //
// client/components/Customer/Cashings/Item.vue